import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { Spacer, Title, Button, Theme,ThirdTitle } from "@dspworkplace/ui";
import WeekPicker from "../../../components/Calendar/week";
import WeekTable from "./week";
import TabPanel from "./tabPanel";
import { WeekProvider } from "./context/weekStore";
import moment from "moment";
import ViewSelector from "../Common/ViewSelector";
import PublishPopUp from "../Common/PublishPopUp";
import { FilterWeekDate } from "../../../hooks/useGlobalData";
import PrintButton from "../Common/PrintButton";
import { useSelectedStation } from "../../../components/StationSelector";
import { showDriverSelection } from "../../SchedulerLoadOut/driverSelection";
import { getCompanyId, useAuth } from "../../../Auth";
import { confirm } from "../../../components/Confirm";
import WeekStore from "./context/weekStore";
import ExportButton from "../Common/ExportButton";
import CopyPreviousWeekShifts from "./components/CopyPreviousWeekShifts";
import { alert } from "../../../components/Alert";
import useSchedulerApi from "../Common/api";
import { TIME_OFF_UNAVAILABLE_SUSPENDED_CATEGORIES } from "../Common/shiftCategories";
import ES from "../../../EventSource";
import { ProgressBar } from "../../../components/UI";
import { showToast } from "../../../Utilities";

const Body = styled.div`
    box-sizing: border-box;
    // max-height: 100vh;
    overflow: hidden;
    padding: 20px 20px 0 20px;

    @media (max-width: 1201px) {
        .title {
            font-size: 32px;
        }
    }
`;

const ActionBox = styled.div`
    display: flex;
    align-items: center;
`;

const ExportActions = styled.div`
    margin-left: auto;
    // display:grid;
    // grid-template-columns: 140px 85px 44px 44px;
    // grid-column-gap:12px;

    .test {
        display: flex;
    }
`;

const Container = styled.div`
    box-sizing: border-box;
    display: flex;
`;

const CopyingWeek = styled.div`
    padding: 2px 8px;
    vertical-align: top;
    position: relative;
    z-index: 1;
    display: inline-flex;
    font-family: ${Theme.font.body}
`;

const PublishChangesStatus = styled.div`
    padding: 2px 8px;
    vertical-align: middle;
    position: relative;
    z-index: 1;
    display: inline-flex;
    font-family: ${Theme.font.body}
`;

const App = () => {
    let [newDate, setNewDate] = FilterWeekDate();
    let [publishShift, setPublishShift] = useState("false");
    const [selectedStation] = useSelectedStation();
    const fakeRefreshData = useState(0);
    const { api } = useAuth();
    let week = moment(newDate).isoWeek();
    if (moment(newDate).day() === 0) {
        week = moment(newDate).add(1, "days").isoWeek();
    }
    let year = parseInt(moment(newDate).startOf("week").format("YYYY"));
    if(moment(newDate).startOf("week").format('YYYY') != moment(newDate).endOf("week").format('YYYY') && week == 1 && year == moment(newDate).startOf("week").format('YYYY')) {
        year = parseInt(moment(newDate).endOf("week").format('YYYY'));
    }
    let dayArr = [];
    for (var i = 0; i < 7; i++) {
        dayArr[i] = moment(newDate).startOf("week").add(i, "days");
    }

    const dateObj = moment(newDate).toDate();
    const currentWeek = moment().isoWeek();
    const currentYear = moment().isoWeekYear();
    const recurringWeeks =  localStorage.getItem('recurringWeeks');
    const recurringLastWeekEndDate = moment().add(15, 'weeks').endOf('isoWeek').format("YYYY-MM-DD");
    const companyId = getCompanyId();
    const [copyingWeek, setCopyingWeek] = useState(null);
    const [loading, setLoading] = useState(false);
    const [updateSchedulerData, setUpdatedSchedulerData] = fakeRefreshData;
    useEffect(() => {
        if((week >= currentWeek && year >= currentYear) || (week < currentWeek && year > currentYear)) {
            setLoading(true);
            findCopyPreviousWeekRunning(); 
    
            const es = new ES("copyPreviousWeek", true);
            es.onmessage = (receiveEvent) => {
                const eventData = receiveEvent.data;
                if (receiveEvent.event === "COPYWEEK" && eventData.station_id == selectedStation && eventData.week == week) {
                    setCopyingWeek(eventData);
                }
            };
    
            return () => {
                es.close();
            };
        }
    },[week,selectedStation]);

   
    
    const findCopyPreviousWeekRunning = async () => {
        setCopyingWeek(null);
        const params = {
            "actions": {
                "response": {
                    "CopyPreviousWeek": {
                        "custom": {
                            "functionName": "findCopyPreviousWeek",
                            "get": "result",
                            "includes": {},
                            "criteria": {
                                "week": week,
                                "year": year,
                                "stationId": selectedStation
                            }
                        }
                    }
                }
            }
        };
        const response = await api.post("/api/lazy/manage/data", params);
        setCopyingWeek(response.data.data?.result);
        setLoading(false);
    }

    return (
        <WeekProvider>
            <Body>
                <ActionBox>
                    <PublishPopUp date="" week={week} year={year} view={"week"} fakeRefreshData={fakeRefreshData} />
                    <Spacer inline left={5}>
                        <Title className={"title"}>
                            {moment(dayArr[0]).format("MMM DD")} – {moment(dayArr[6]).format("MMM DD")},{" "}
                            {moment(dayArr[6]).format("YYYY")}
                        </Title>
                    </Spacer>
                    <ExportActions>
                        <PublishShiftCount></PublishShiftCount>
                        {copyingWeek && copyingWeek?.disabled === true && (<><CopyingWeekInProgress copyingWeek={copyingWeek}/>
                            <Spacer inline right={3} />
                        </>)}
                        <WeekPicker date={newDate} onChange={(date) => setNewDate(moment(date).format("YYYY-MM-DD"))} />
                        <Spacer inline right={3} />
                        {((week >= currentWeek && year >= currentYear) || (week < currentWeek && year > currentYear)) &&
                            (
                                <CopyPreviousWeekShifts
                                    week={week}
                                    year={year}
                                    isCurrentWeek={week == currentWeek && year == currentYear}
                                    stationId={selectedStation}
                                    disabledBtn={copyingWeek && copyingWeek?.disabled ? copyingWeek?.disabled : loading}
                                />
                            )}
                        <Spacer inline right={3} />
                        <PrintWeekWiew week={week} selectedStation={selectedStation} year={year}></PrintWeekWiew>
                        <Spacer inline right={3} />
                        <ExportWeekWiew week={week} year={year}></ExportWeekWiew>
                        <Spacer right={3} inline />
                        <ViewSelector />
                    </ExportActions>
                </ActionBox>
                <Spacer top={5} />
                <Container>
                    <TabPanel>
                        <Spacer top={5}>
                            <AddDriverButton />
                        </Spacer>
                    </TabPanel>

                    <WeekTable
                        year={year}
                        weekDateObj={dateObj}
                        week={week}
                        fakeRefreshData={fakeRefreshData}
                        setPublishShift={setPublishShift}
                    />
                </Container>
            </Body>
        </WeekProvider>
    );
};

const sortData = (array, fields, direction = 0) => {
    return array.sort((a, b) => {
        const strA = fields.reduce((str, key) => `${str}~${a[key]}`, "");
        const strB = fields.reduce((str, key) => `${str}~${b[key]}`, "");
        if (direction === 0) {
            return strA.localeCompare(strB);
        } else {
            return strB.localeCompare(strA);
        }
    });
};

const AddDriverButton = () => {
    const [state, dispatch] = useContext(WeekStore);
    let [newDate, setNewDate] = FilterWeekDate();
    const [selectedStation] = useSelectedStation();
    const { api } = useAuth();
    const schedulerApi = useSchedulerApi();
    
    const handleAddDriver = async () => {
        showDriverSelection({}, api, {
            type: "SCHEDULER_ADD_ROUTE_WITH_DATE",
            station: selectedStation,
            stationTimezone: JSON.parse(localStorage.getItem("station")).timezone,
            date: newDate,
        }).then(async (data) => {
            if (!data) return;
            let day7ConsecutiveShift = null;
            data.driver = data.driver;
            // ignore seven day consecutive shift dialog confirm box
            const is_TimeOff_UnAvailable_Suspended_ShiftCategory = TIME_OFF_UNAVAILABLE_SUSPENDED_CATEGORIES.includes(data?.extra?.category);
            if (is_TimeOff_UnAvailable_Suspended_ShiftCategory !== true) {
                const params1 = {
                    actions: {
                        response: {
                            DriverRoute: {
                                custom: {
                                    functionName: "checkSequenceDriverRoute",
                                    get: "checkSequenceDriverRoute",
                                    excludes: [],
                                    criteria: {
                                        routeId: "",
                                        driverId: data.driver,
                                        newDate: data.date,
                                    },
                                },
                            },
                        },
                    },
                };
                const response = await api.post("/api/lazy/manage/data", params1);
                if (response.data.data.checkSequenceDriverRoute.status) {
                    const wc = await confirm(response.data.data.checkSequenceDriverRoute.message.web);
                    if (!wc) return undefined;
                    day7ConsecutiveShift = response.data.data.checkSequenceDriverRoute.message.bot;
                }
            }

            const params2 = {
                actions: {
                    response: {
                        DriverRoute: {
                            custom: {
                                functionName: "check60WorkHoursWeb",
                                get: "check60WorkHoursWeb",
                                excludes: [],
                                criteria: {
                                    company: getCompanyId(),
                                    station:data.station,
                                    drivers: data.driver.map((d) => {return { 'selectedDate' : [moment(data.date).format("YYYY-MM-DD")], 'driverId' : d, 'routeId' : "" }}),
                                    newDate: moment(data.date).format("YYYY-MM-DD"),
                                    startTime: data.startTime,
                                    endTime: data.endTime,
                                    type: "multiple",
                                    shiftId: data.shift
                                },
                            },
                        },
                    },
                },
            };
            const responseDriver60Hours = await api.post("/api/lazy/manage/data", params2);
            if (responseDriver60Hours.data.data.check60WorkHoursWeb != "") {
                const confirmation = await confirm(responseDriver60Hours.data.data.check60WorkHoursWeb);
                if (!confirmation) {
                    return true;
                }
            }

            const criteria = {
                shift: data.shift,
                driverId: data.driver,
                invoiceType: data.invoiceType,
                routeStatus: data.routeStatus,
                startTime: data.startTime,
                endTime: data.endTime,
                timezoneOffset: new Date().getTimezoneOffset(),
                date: data.date,
                station: selectedStation,
                inactiveCurrent: data.inactiveCurrent,
                backupStatus: data.backupStatus,
                onCall: data.onCall,
                view: 'week',
            };
            const params = {
                actions: {
                    response: {
                        DriverRoute: {
                            custom: {
                                functionName: "schedulerLoadOutAddDriverSave",
                                get: "result",
                                excludes: [
                                    "skill",
                                    "vehicle",
                                    "device",
                                    "driver",
                                    "station",
                                    "shiftType",
                                    "schedule",
                                    "vehicleDriverRecord",
                                    "status",
                                    "tempDriverRoutes",
                                    "kickoffLog",
                                    "returnToStation",
                                    "oldDriver",
                                    "oldDriverRoute",
                                    "driverRoutes",
                                    "oldTempDriverRoutes",
                                ],
                                criteria,
                            },
                        },
                    },
                },
            };
            try {
                const response = await api.post("/api/lazy/manage/data", params);
                if (data.station == selectedStation) {
                    const weekDate = moment(data.date).utc().format("YYYY-MM-DD");
                    if (data.inactiveCurrent == true) {
                        window.dispatchEvent(new Event('scheduler-week-refresh'));
                    } else {
                        let responseHoursWorks = await schedulerApi.updateDriverScheduleHourWorks(data.date, state.selectedStation);
                        if (responseHoursWorks) {
                            dispatch({
                                type: "UPDATE_DRIVER_WORK_HOURS",
                                payload: {
                                    driverHoursWork: responseHoursWorks.data.data.result
                                },
                            });
                        }
                        let responseSchedulerFooterData = await schedulerApi.getSchedulerFooterData(data.date, state.selectedStation);
                        if (responseSchedulerFooterData) {
                            dispatch({
                                type: "UPDATE_SCHEDULER_FOOTER_TABLE_DATA",
                                payload: {
                                    schedulerFooterData: responseSchedulerFooterData.data.data.schedulerFooterData,
                                },
                            });
                        }
                        if(response.data.data.result.shiftData != null) {
                            dispatch({
                                type: "ADD_DRIVER_WITH_SHIFT",
                                payload: {
                                    to: {
                                        driverId: response.data.data.result.shiftData.driverId,
                                        week: moment(weekDate).weekday(),
                                    },
                                    item: response.data.data.result.shiftData,
                                    hasAlert: true,
                                },
                            });
                        }
                        dispatch({
                            type: "ORDER",
                            payload: {
                                mainFields: [
                                    "firstName",
                                    "workHours"
                                ]
                            },
                        });
                    }
                } else {
                    window.dispatchEvent(new Event('scheduler-week-refresh'));
                }
                if (day7ConsecutiveShift != null && !TIME_OFF_UNAVAILABLE_SUSPENDED_CATEGORIES.includes(data?.extra?.category)) {
                    const params1 = {
                        actions: {
                            response: {
                                DriverRoute: {
                                    custom: {
                                        functionName: "createEventForConsicutiveShift",
                                        get: "createEventForConsicutiveShift",
                                        excludes: [],
                                        criteria: {
                                            driverId: data.driver,
                                            message: day7ConsecutiveShift,
                                        },
                                    },
                                },
                            },
                        },
                    };
                    await api.post("/api/lazy/manage/data", params1);

                }
                if (response.data.data.result.driverNameStr != null) {
                    const dialogMsg = `The new shift time overlaps with an existing shift. You cannot add this driver shift for ${response.data.data.result.driverNameStr}`;
                    alert({
                        title: "Overlap Shift Time",
                        text: dialogMsg,
                        btnText: "Cancel",
                    });
                }
                return true;
            } catch (error) {
                if (error.response.status === 400) {
                    showToast({
                        type: 'Error',
                        title: 'We are sorry 😥.',
                        content: `Something went wrong. Please try again`,
                    });
                    return;
                }
                if (error.response.status == "401") {
                    window.location = "/logout";
                }
            }
        });
    };

    return (
        <Button
            size="small"
            onClick={() => {
                handleAddDriver();
            }}
            type={"default"}
        >
            Add Driver
        </Button>
    );
};

const ExportWeekWiew = (props) => {
    const [state, dispatch] = useContext(WeekStore);
    return (
        <ExportButton
            params={{
                actions: {
                    response: {
                        DriverRoute: {
                            custom: {
                                functionName: "getDriverShiftForWeekViewForExport",
                                get: "file",
                                criteria: {
                                    data: {
                                        listData: state.filter, footerData: state.schedulerFooterData
                                    },
                                    weekNumber: props.week,
                                    yearNumber: props.year,
                                },
                            },
                        },
                    },
                },
            }}
        />
    );
};

const PrintWeekWiew = ({week,year,selectedStation, ...props}) => {
    const [state, dispatch] = useContext(WeekStore);
    return (
        <PrintButton
            params={{
                actions: {
                    response: {
                        DriverRoute: {
                            custom: {
                                functionName: "createWeekViewPDF",
                                get: "file",
                                criteria: {
                                    station: selectedStation,
                                    wknumber: week,
                                    year: year,
                                    data: {
                                        schedulerRouteData: state.filter, schedulerFooterDataArray: state.schedulerFooterData
                                    },
                                },
                            },
                        },
                    },
                },
            }}
        />
    );
};

const CopyingWeekInProgress = ({ copyingWeek }) => {
        
    return (
        <CopyingWeek>
            <ProgressBar progress={copyingWeek.percentage} description={copyingWeek.text}/>
        </CopyingWeek>
    )
}
const PublishShiftCount = () => {
    const [state, dispatch] = useContext(WeekStore);

    return ((state.disabledDriverRouteTemp && state.disabledDriverRouteTemp.length > 0)?
        <PublishChangesStatus>
            <ThirdTitle>{ ' Publishing ('+state.disabledDriverRouteTemp.length+' Remains) ...'}</ThirdTitle>
        </PublishChangesStatus> :
        <></>
    )
}

export default App;
